import { z } from 'zod'
import { geoAddressSchema } from '@/modules/sales/clients/types/geoAddressSchema.ts'
import { clientAddressSchema } from '@/modules/sales/clients/types/Article.ts'
import { addressSchema } from '@/modules/sales/clients/components/assignArticle/components/supplierAutomotive/assignMotorbikeArticles/assignArticleFormSchema.ts'
import { genderSchema } from '@/modules/sales/clients/types/personalData/personalDataSchemas.ts'

export const clientPersonalDataSchema = z.object({
  address: z.string().max(300, 'Máximo 300 caracteres').optional().nullable(),
  gender: z.string().optional().nullable(),
  accountNumber: z.string().optional().nullable(),
  accountType: z.string().optional().nullable(),
  occupation: z
    .string()
    .max(100, 'Máximo 100 caracteres')
    .optional()
    .nullable(),
  maritalStatus: z.string().optional().nullable(),
  addresses: z.array(geoAddressSchema).optional()
})

const commonFields = {
  gender: genderSchema.nullable(),
  accountNumber: z.string().nullable(),
  accountType: z.string().nullable(),
  occupation: z
    .string()
    .max(100, 'Máximo 100 caracteres')
    .optional()
    .nullable(),
  maritalStatus: z.string().nullable()
}

// Shape of the GET endpoint response
const basePersonalDataSchema = z.object({
  clientAddress: clientAddressSchema,
  ...commonFields
})

// Shape used by the form and the update endpoint
const basePersonalDataFormSchema = z.object({
  clientAddress: addressSchema,
  ...commonFields
})

export const personalDataSchema = basePersonalDataSchema.merge(
  z.object({
    clientId: z.number()
  })
)

export const personalDataFormSchema = basePersonalDataFormSchema

const personalDataDTOSchema = basePersonalDataFormSchema
  .omit({
    clientAddress: true
  })
  .merge(
    z.object({
      addresses: z.array(addressSchema)
    })
  )

export type PersonalDataDTO = z.infer<typeof personalDataDTOSchema>
